"use client";

import Footer from "@/components/footer";
import ContactUs from "@/components/contact-us";
import Navbar from "@/components/navbar";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { allPortfolios } from "contentlayer/generated";
import { FaPlus } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const data = {
  title: (
    <>
      <span className="text-[#E1240A] font-medium">Asynq</span> is leading the
      way in software design and development in the financial industry. See how
      we deliver measurable impact.
    </>
  ),
  desc: "Our work transforms your industry.",
  heading1: "With over 5+ years industry experience",
  intro1:
    "…we have acted as a trusted advisor for companies worldwide, supporting businesses with technology that delivers bottom-line impact and solves real-life challenges. We've helped others and we'll know how to help you too. If you want to understand how a similar project could look like at your company, leave us your email address and we’ll get back to you and explain our processes.",

  heading2: "A partner that’s got you covered.",
  intro2:
    "At Asynq, we really focus on the individual approach to the employee. That’s probably the only sensible thing to do for companies in the IT industry – betting on people, because what good is a project without a great team to deliver it?",
};

const allTags = [
  ...new Set(allPortfolios.map((portfolio) => portfolio.tags).flat()),
  "All",
];

function PorfolioPgae() {
  const [activeTag, setActiveTag] = useState(["All"]);

  const filteredPortfolioProjects = [
    ...allPortfolios.filter((portfolio) => {
      if (!activeTag.length || activeTag.includes("All")) return true;
      for (const tag of portfolio.tags) {
        if (activeTag.includes(tag)) {
          return true;
        }
      }
      return false;
    }),
  ];

  filteredPortfolioProjects.sort((proj) => (proj.featured ? -1 : 1));

  return (
    <>
      <Navbar />
      <div className="bg-palette-dark-3 pt-20 min-h-screen flex items-center">
        <main className="max-w-screen-xl mx-auto px-4 lg:px-8">
          <div className="flex flex-col gap-10 items-center justify-center lg:flex-row lg:[&>div]:w-1/2">
            <div>
              <Image
                src={"/assets/styled/black-orange-hex.png"}
                alt=""
                width={500}
                height={500}
                className="lg:w-[600px]"
              />
            </div>
            <div className="text-palette-neutral-1 py-8">
              <p className="text-2xl">{data.title}</p>
              <h1 className="text-5xl font-medium lg:text-7xl mt-8">
                {data.desc}
              </h1>
            </div>
          </div>
        </main>
      </div>
      <div className="bg-palette-neutral-1">
        <div className="flex flex-col gap-8 justify-center items-center lg:flex-row lg:[&>div]:w-1/2">
          <div className="p-4 lg:px-10 py-12">
            <p className="font-medium text-3xl lg:text-5xl">{data.heading1}</p>
            <p className="mt-8 lg:text-2xl">{data.intro1}</p>
          </div>
          <div className="">
            <Image
              src={"/assets/images/team-port.jpg"}
              alt=""
              width={1920}
              height={1080}
              className="w-full object-cover"
            />
          </div>
        </div>
      </div>
      <div className="bg-palette-dark-3 text-palette-neutral-1 min-h-screen py-12 lg:py-24">
        <div className="max-w-screen-2xl mx-auto">
          <p className="text-3xl lg:text-6xl font-medium text-center">
            Our Projects
          </p>
          <ul className="flex gap-8 flex-wrap items-center justify-center p-8 mt-12">
            {allTags.map((tag) => (
              <li key={tag}>
                <button
                  onClick={() => {
                    if (tag === "All" && activeTag.length > 0) {
                      return setActiveTag(["All"]);
                    } else if (activeTag.includes(tag)) {
                      setActiveTag(activeTag.filter((_tag) => tag !== _tag));
                    } else if (!activeTag.includes("All")) {
                      setActiveTag([...activeTag, tag]);
                    } else {
                      setActiveTag([tag]);
                    }
                  }}
                  className={cn(
                    "min-w-[4rem] text-center rounded-full px-4 py-2",
                    "border-[1.5px] border-palette-primary-2 hover:bg-palette-primary-2",
                    "hover:text-palette-neutral-1 transition-[colors,transform] duration-300",
                    "flex items-center justify-center gap-4",
                    activeTag.includes(tag) &&
                      "bg-palette-primary-2 -translate-y-5",
                    activeTag.length < 1 &&
                      tag === "All" &&
                      "bg-palette-primary-2 -translate-y-5",
                  )}>
                  <span>{tag}</span>
                  {activeTag.includes(tag) ||
                  (activeTag.length < 1 && tag === "All") ? (
                    <FaXmark className="w-3 h-3" />
                  ) : (
                    <FaPlus className="w-3 h-3" />
                  )}
                </button>
              </li>
            ))}
          </ul>
          <div className="mt-8 px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-14">
            <AnimatePresence>
              {filteredPortfolioProjects.map((portfolio) => (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  key={portfolio.title}
                  className="flex hover:scale-105 transition-transform duration-300 relative overflow-hidden">
                  {portfolio.featured && (
                    <div className="drop-shadow-md">
                      <div className="ribbon text-lg text-black font-medium z-10">
                        Featured
                      </div>
                    </div>
                  )}
                  <Link href={`portfolio/${portfolio.slug}`} className="flex">
                    <div className="flex flex-col gap-4 bg-palette-neutral-2 text-palette-neutral-4 rounded-lg p-8 group">
                      <div className="rounded-lg overflow-hidden">
                        <Image
                          src={portfolio.image}
                          alt=""
                          width={500}
                          height={500}
                          className="aspect-video object-cover"
                        />
                      </div>
                      <div>
                        <p className="text-2xl font-medium">
                          {portfolio.title}
                        </p>
                        <p className="mt-4 text-sm">{portfolio.description}</p>
                      </div>
                      <ul className="flex mt-auto gap-2">
                        {portfolio.tags.map((tag) => (
                          <li
                            key={tag}
                            className={cn(
                              "min-w-[4rem] text-center rounded-full px-4 py-2",
                              "border-[1.5px] border-palette-primary-2",
                              "transition-colors duration-300",
                            )}>
                            {tag}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </div>
      <div className="bg-palette-neutral-1">
        <div className="flex flex-col gap-8 justify-center items-center lg:flex-row lg:[&>div]:w-1/2">
          <div className="">
            <Image
              src={"/assets/images/office.jpg"}
              alt=""
              width={1920}
              height={1080}
              className="w-full object-cover"
            />
          </div>
          <div className="p-4 lg:px-10 py-12">
            <p className="font-medium text-3xl lg:text-5xl text-center">
              {data.heading1}
            </p>
            <q className="block mt-8 lg:text-xl italic text-center">
              {data.intro2}
            </q>
          </div>
        </div>
      </div>
      <div className="p-4 py-10 lg:px-12 lg:py-32 relative">
        <Image
          src="/assets/styled/diamond-discuss.png"
          width={500}
          height={500}
          alt=""
          className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-1/2 -z-10"
        />
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-24 items-center lg:items-start max-w-screen-xl mx-auto">
          <div className="flex flex-col gap-4 items-center text-center lg:text-start lg:items-start lg:pt-10 lg:basis-1/2">
            <p className="text-3xl lg:text-5xl font-medium">
              Let’s discuss how we can work together to achieve your goals
            </p>
            <p className="text-xl lg:text-2xl font-medium">
              If you have a requirement you’d like to discuss with technical
              experts, schedule a free consultation to see if we’re a good fit
              to help.
            </p>
          </div>
          <ContactUs />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PorfolioPgae;
